<template>
  <div id="contenedor-firma">
    
      <!-- <p> irelevant text to ocupy space before panel</p> -->
      <div class="panel">
        <div class="panel-header">
          I'm a header.
        </div>
        <div class="panel-main" id="panel-firma">
          <VueSignaturePad
            :width="width"
            :height="height"
            :options="options"
            saveType="image/jpeg" 
            ref="signaturePad"
            :customStyle="stylePad"
            id="canvas-firma"
          />
        </div>
        <div class="panel-footer">
          <div id="botones">
            <q-btn color="primary" label="Guardar" @click="save" />
            <q-btn color="secondary" label="Revertir" @click="undo" />
            <q-btn color="secondary" label="Borrar" @click="clear" />
            <q-btn color="secondary" label="Bloquear" @click="lock" />
            <q-btn color="secondary" label="Desbloquear" @click="unlock" />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import {authHeader} from './../_helpers/_auth-header'
import {dataURItoBlob} from './../_helpers/dataURItoBlob'
import axios from 'axios'
import { mapMutations, mapActions } from 'vuex'
import VueSignaturePad from 'vue-signature-pad'

Vue.use(VueSignaturePad);

export default {
  props: ['empresa_id', 'pedido_id'],
  name: 'Firma',
  data() {
    return {
      maxHeight: 0,
      navHeight: 0,
      width: '99%',
      // height: '480px',
      height: '99%',
      options: {
        // backgroundColor: 'rgb(221, 221, 221)',
        backgroundColor: 'rgb(255, 255, 255)',
      },
      stylePad: {
        border: 'black 1px solid'
      },
      dataURI: ''
    }
  },
  computed: {
    urlApiPedidoArchivos() {
      return this.$store.state.urlBase + `/api/v3/${this.empresa_id}/pedidos/archivos/${this.pedido_id}`;
    },
    firma() {
      return this.$store.state.firma.dataURI;
    }
  },
  methods: {
    ...mapMutations(['setFirma']),
    ...mapActions(['storeFirma']),
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      
      if (!isEmpty) {
        this.dataURI = data;
        this.setFirma({
          dataURI: data, 
          empresa_id: this.empresa_id, 
          pedido_id: this.pedido_id
          });
        this.clear();
      } else {
        this.dataURI = '';
      }
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    lock() {
      this.$refs.signaturePad.lockSignaturePad();
    },
    unlock() {
      this.$refs.signaturePad.openSignaturePad();
    },
    resizeCanvas(event) {
      
      this.$nextTick(function () {
        console.log('redimensionando canvas');
        let canvas = document.getElementsByTagName('canvas')[0];
        let panelFirma = document.getElementById('panel-firma');
        var ratio =  Math.max(window.devicePixelRatio || 1, 1);

        console.log('canvas:',canvas.offsetWidth, canvas.offsetHeight);
        console.log('panelFirma:',panelFirma.offsetWidth, panelFirma.offsetHeight);
        // canvas.width = canvas.offsetWidth * ratio;
        // canvas.height = canvas.offsetHeight  * ratio;
        canvas.width = panelFirma.offsetWidth * ratio;
        canvas.height = panelFirma.offsetHeight * ratio;
        // console.log(this.width, this.height);
        
        canvas.getContext("2d").scale(ratio, ratio);
        // signaturePad.clear(); // otherwise isEmpty() might return incorrect value
        // signaturePad.clear()

        console.log('dentro de nextTick resize');
        this.$refs.signaturePad.clearSignature();
        this.$refs.signaturePad.resizeCanvas();
      })
    },
    resizeCanvas2(event) {
      console.log('resize 2');
      let canvas = document.getElementsByTagName('canvas')[0];
      let panelFirma = document.getElementById('panel-firma');
      
      console.log('canvas:',canvas.offsetWidth, canvas.offsetHeight);
      console.log('panelFirma:',panelFirma.offsetWidth, panelFirma.offsetHeight);
      
      this.$refs.signaturePad.clearSignature();
      this.$refs.signaturePad.resizeCanvas();
    },

  },
  mounted() {
    console.log('componente firma montado');
    this.$nextTick(function () {
      console.log('dentro de nextTick...');
      // this.$refs.signaturePad.resizeCanvas()
      this.resizeCanvas()
    })
  },
  created() {
    console.log('componente firma creado');
  },
  deactivated() {
    console.log('desactivando componente firma');
    window.removeEventListener('resize', this.resizeCanvas);
    },
  activated() {
    console.log('activando componente firma');
    window.addEventListener("resize", this.resizeCanvas);
    
    // this.width = window.devicePixelRatio;
    // this.maxHeight = document.body.clientHeight;
    // this.navHeight = document.getElementsByTagName('nav')[0].clientHeight
    // let width = document.getElementById('firma').offsetWidth;
    // this.width = width.toString();
    // this.height = (width * 0.75).toString();
    
  }
}
</script>

<style lang="scss">
#contenedor-firma {
  // height:100%;
  // display:flex;
  // flex:1;
  width: 100%;
}
.q-pa-md{
  flex:1;
  display:flex;
  flex-direction:column;
}
 /* end update 1*/
.panel {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  flex-grow:1; 
  justify-content: flex-start; /* align items in Main Axis */
  align-items: stretch; /* align items in Cross Axis */
  align-content: stretch; /* Extra space in Cross Axis */

  background-color: #00acc1;
  }
.panel-header{
  flex: 0 1 auto;
    /*max-height: fit-content;*/
  }
.panel-main{
  /*margin-bottom: auto;*/
  display: flex;
  flex-direction: column;
  flex: 1; /* same as flex: 1 1 auto; */
  justify-content: flex-start; /* align items in Main Axis */
  align-items: stretch; /* align items in Cross Axis */
  align-content: stretch; /* Extra space in Cross Axis */
  background-color: #0d47a1;
}
.panel-footer{
  margin-top: auto;
  max-height: fit-content;
}
</style>